// extracted by mini-css-extract-plugin
export default {"FAQ":"FAQ_FAQ__3CEWe","Item":"FAQ_Item__x9zdu"};